import type { Lang } from '@platform/core/types';
import { i18n, moduleBundle, moduleNamespace } from '@platform/i18n';
import { findModule } from '@platform/modularity';

const pending = new Map<string, Promise<void>>();

/**
 * Лише рядки i18n пакета модуля (namespace `module.<ключ>`), без зрізу стану, подань і визначення — для підписів оболонки (опис модуля на
 * плитках Головної, навігатора Ctrl+K, «Усіх модулів», огляду напряму; однина типу в «Нещодавніх змінах»). Уже завантажений пакет (і
 * через loadModule) не вантажиться вдруге; невдала спроба вилучається з кешу, тож наступний виклик повторює її.
 */
export function loadModuleStrings(moduleKey: string, lang: Lang): Promise<void> {
  if (moduleBundle(lang, moduleKey)) return Promise.resolve();
  const manifest = findModule(moduleKey);
  if (!manifest) return Promise.resolve();
  const cacheKey = `${moduleKey}|${lang}`;
  let loading = pending.get(cacheKey);
  if (!loading) {
    loading = manifest.loadI18n(lang).then((strings) => { i18n.addResourceBundle(lang, moduleNamespace(moduleKey), strings, true, true); });
    loading.catch(() => pending.delete(cacheKey));
    pending.set(cacheKey, loading);
  }
  return loading;
}
